import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    animation: { type: String, default: "fade-up" }
  }

  connect() {
    this.setupInitialState()
    this.setupObserver()
  }

  setupInitialState() {
    // Base styles for all animations
    this.element.classList.add("transition-all", "duration-1000", "ease-out")

    switch (this.animationValue) {
      case "zoom-in":
        this.element.classList.add("opacity-0", "scale-75")
        break
      case "zoom-out":
        this.element.classList.add("opacity-0", "scale-125")
        break
      default: // fade-up
        this.element.classList.add("opacity-0", "translate-y-8")
    }
  }

  setupObserver() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Remove initial state classes
          this.element.classList.remove("opacity-0", "scale-75", "scale-125", "translate-y-8")
          // Add final state classes
          this.element.classList.add("opacity-100", "scale-100", "translate-y-0")
          
          // Optional: Unobserve after animation
          observer.unobserve(this.element)
        }
      })
    }, { 
      threshold: 0.1,
      rootMargin: "50px"
    })

    observer.observe(this.element)
  }

  loadMore(event) {
    event.preventDefault()
    const frame = document.querySelector("turbo-frame#learn_more_frame")
    frame.innerHTML = `
      <div class='mt-6 text-lg'>
        At RightRole, we believe everyone has a place where they can thrive. Let's help you find yours.
      </div>
    `
  }
}
